import { FC, ReactNode, useState, useMemo } from 'react';
import { SidebarContext } from './SidebarContext';

type SidebarProviderProps = {
  children: ReactNode;
};

export const SidebarProvider: FC<SidebarProviderProps> = ({ children }) => {
  const [isSidebarActive, setIsSidebarActive] = useState(false);
  const [isSidebarAnchored, setIsSidebarAnchored] = useState(false);

  const value = useMemo(
    () => ({
      isSidebarActive,
      isSidebarAnchored,
      setIsSidebarActive,
      setIsSidebarAnchored,
    }),
    [isSidebarActive, isSidebarAnchored]
  );

  return (
    <SidebarContext.Provider value={value}>{children}</SidebarContext.Provider>
  );
};
